import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Grid } from '@mui/material';
import { styled } from '@mui/material';
import Scanner from '../../molecules/Scanner';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
const SearchBarContainer = styled('div') `
  width: 100%;
`;
export const SearchBar = ({ onChange, onClear, onSubmit, showFilter = true, width = 300, maxWidth = 600, value = '', className = '', helperText, disabled = false, }) => {
    const [error, setError] = useState();
    const handleSubmit = (event) => {
        const value = event?.target?.value;
        if (value) {
            onSubmit?.(value);
        }
        else {
            setError('You should enter a value to search');
        }
    };
    const handleChange = (event) => {
        const value = event?.currentTarget?.value ?? '';
        onChange?.(value);
        setError(undefined);
    };
    const handleClear = () => {
        onClear?.();
        setError(undefined);
    };
    return (_jsx(SearchBarContainer, { sx: { maxWidth }, className: className, children: _jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, xs: showFilter ? 8 : 12, style: { marginTop: 16 }, children: _jsx(Scanner, { width: width, autoFocus: true, showIcon: true, icon: _jsx(SearchIcon, {}), onScannerChange: handleChange, onEnter: handleSubmit, onClear: handleClear, hasError: !!error, helperText: error ?? helperText, placeholder: "Search", value: value, disabled: disabled }) }), showFilter && _jsx(Grid, { item: true, xs: 4, children: _jsx(FilterListIcon, { color: "disabled", style: { marginLeft: 10, marginTop: 30 } }) })] }) }));
};
//# sourceMappingURL=index.js.map